import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { mkRoutes } from './_';
import { onSubdomain, generalUrls, accountUrls, landingUrls, exploreUrls, paymentUrls, propertyUrls, orgUrls, } from './urls/general';
import AuthScreen from '../../screens/general/auth-screen';
import InviteLanding from '../../screens/general/invite-landing';
import TourInviteLanding from '../../screens/general/tour-invite';
import E404 from '../../screens/system/404';
import UnsubscribePage from '../../screens/system/unsubscribe';
import HomeV2 from '../../screens/landing-site/home-v2';
import Pricing from '../../screens/landing-site/pricing';
import ProCheckout from '../../screens/landing-site/pro-checkout';
import Account, { tabs as AccountTabs } from '../../screens/landing-site/account';
import Policy from '../../screens/landing-site/policy';
import Tours from '../../screens/landing-site/tours';
import TourNotFound from '../../screens/landing-site/tour-not-found';
import ExploreMapPage from '../../screens/landing-site/explore-map';
import DistrictLayout from '../../layout/page-layout';
import PublicLayout from '../../layout/public-layout';
import Property from '../../screens/general/property';
import UnclaimedProperty from '../../screens/general/unclaimed-property';
import AddressProperty from '../../screens/general/address-property';
import OrgStoryScreen from '../../screens/general/org-story';
import MyProperty from '../../screens/owner/parcel-property/_index';
export { onSubdomain };
const tenantAwareLayout = (node) => onSubdomain
    ? _jsx(DistrictLayout, { children: node })
    : _jsx(PublicLayout, { children: node });
export const [generalRoutes, generalRoutesArray] = mkRoutes(generalUrls, {
    notFound: E404,
    login: () => tenantAwareLayout(_jsx(AuthScreen, { authMode: "sign-in" })),
    signUp: () => tenantAwareLayout(_jsx(AuthScreen, { authMode: "sign-up" })),
    invite: () => tenantAwareLayout(_jsx(InviteLanding, {})),
    tourInvite: ({ token }) => tenantAwareLayout(_jsx(TourInviteLanding, { token: token })),
    unsubscribe: UnsubscribePage,
});
const hasKey = (value, key) => key in value;
export const [accountRoutes, accountRoutesArray] = mkRoutes(accountUrls, {
    accountDefault: () => tenantAwareLayout(_jsx(Account, { tab: AccountTabs['my-properties'] })),
    account: ({ tab }) => hasKey(AccountTabs, tab) && !!AccountTabs[tab] ? tenantAwareLayout(_jsx(Account, { tab: AccountTabs[tab] })) : null,
    myPropertiesManage: ({ id }) => tenantAwareLayout(_jsx(Account, { tab: AccountTabs['my-properties'], title: "My Property", children: _jsx(MyProperty, { id: id }) })),
    myProperty: ({ id }) => tenantAwareLayout(_jsx(Account, { tab: AccountTabs['my-properties'], title: "My Property", children: _jsx(MyProperty, { id: id }) })),
});
export const [landingRoutes, landingRoutesArray] = mkRoutes(landingUrls, {
    root: () => _jsx(PublicLayout, { children: _jsx(HomeV2, {}) }),
    policy: (props) => _jsx(PublicLayout, { children: _jsx(Policy, Object.assign({}, props)) }),
    tours: () => _jsx(PublicLayout, { children: _jsx(Tours, {}) }),
    tourNotFound: () => _jsx(PublicLayout, { children: _jsx(TourNotFound, {}) }),
});
export const [exploreRoutes, exploreRoutesArray] = mkRoutes(exploreUrls, {
    explore: (props) => _jsx(PublicLayout, { children: _jsx(ExploreMapPage, Object.assign({}, props)) }),
});
export const [paymentRoutes, paymentRoutesArray] = paymentUrls ? mkRoutes(paymentUrls, {
    pricing: (props) => _jsx(PublicLayout, { children: _jsx(Pricing, Object.assign({}, props)) }),
    proCheckout: (props) => _jsx(PublicLayout, { children: _jsx(ProCheckout, Object.assign({}, props)) }),
}) : [null, []];
export const [propertyRoutes, propertyRoutesArray] = mkRoutes(propertyUrls, {
    property: onSubdomain
        ? ({ id }) => React.createElement(DistrictLayout, {
            'children': React.createElement(Property, { id }),
        })
        : ({ id }) => React.createElement(PublicLayout, {
            'children': React.createElement(Property, { id }),
        }),
    parcel: onSubdomain
        ? ({ id }) => React.createElement(DistrictLayout, {
            'children': React.createElement(UnclaimedProperty, { id }),
        })
        : ({ id }) => React.createElement(PublicLayout, {
            'children': React.createElement(UnclaimedProperty, { id }),
        }),
    address: onSubdomain
        ? () => React.createElement(DistrictLayout, {
            'children': React.createElement(AddressProperty),
        })
        : () => React.createElement(PublicLayout, {
            'children': React.createElement(AddressProperty),
        }),
});
// On the root host the story screen mounts the platform's navbar over the organization's footer.
export const [orgRoutes, orgRoutesArray] = mkRoutes(orgUrls, {
    story: onSubdomain
        ? ({ org, id }) => React.createElement(DistrictLayout, {
            'children': React.createElement(OrgStoryScreen, { org, id }),
        })
        : ({ org, id }) => React.createElement(OrgStoryScreen, { org, id }),
});
